export const theme = {
    color: {
        white: "#FFFFFF",
        black: "#000000",
        green: "#40916c",
        silverTree: "#67B99A",
    }
};